import { render, staticRenderFns } from "./IndexThresholdSlider.vue?vue&type=template&id=04007c56&scoped=true&"
import script from "./IndexThresholdSlider.vue?vue&type=script&lang=js&"
export * from "./IndexThresholdSlider.vue?vue&type=script&lang=js&"
import style0 from "./IndexThresholdSlider.vue?vue&type=style&index=0&id=04007c56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04007c56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04007c56')) {
      api.createRecord('04007c56', component.options)
    } else {
      api.reload('04007c56', component.options)
    }
    module.hot.accept("./IndexThresholdSlider.vue?vue&type=template&id=04007c56&scoped=true&", function () {
      api.rerender('04007c56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company-settings/IndexThresholdSlider.vue"
export default component.exports